import { Directive, inject, input } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { EntriesService } from 'superlikers-microsites-api'

@Directive({
  selector: '[clicks]',
  host: { '(click)': 'onClick($event)' }
})
export class Clicks {
  name = input<string>('No text provided', { alias: 'clicks' })
  preventDefault = input<boolean>(true)

  entriesService = inject(EntriesService)

  #isProcessing = false

  async onClick(event: MouseEvent) {
    if (this.#isProcessing) return
    this.#isProcessing = true

    if (this.preventDefault()) {
      event.preventDefault()
    }

    const properties = { name: this.name() }

    const response$ = this.entriesService.sendExternal({ event: 'Clicks', properties, category: this.name() })
    await firstValueFrom(response$)

    this.#isProcessing = false
  }
}
